// ─── API Response Envelope Types (V5 format) ────────────────────────────────

export interface ApiResponse<T> {
  data: T;
  meta?: Record<string, unknown>;
}

export interface PaginatedResponse<T> {
  data: T[];
  meta: PaginationMeta;
}

export interface PaginationMeta {
  total?: number;
  page?: number;
  perPage?: number;
  totalPages?: number;
  hasNext?: boolean;
  [key: string]: unknown;
}

// ─── API Error (V5 format) ───────────────────────────────────────────────────

export interface ApiError {
  error: {
    code: string;
    message: string;
    details?: unknown;
  };
  /** Laravel validation errors (422 responses) */
  errors?: Record<string, string[]>;
  message?: string;
}

/** Type guard — narrows an unknown catch value to an Axios error with V5 body */
export function isApiError(err: unknown): err is { response: { data: ApiError } } {
  return (
    typeof err === 'object' &&
    err !== null &&
    'response' in err &&
    typeof (err as Record<string, unknown>).response === 'object'
  );
}

// ─── Common request param shapes ─────────────────────────────────────────────

export interface ListParams {
  page?: number;
  limit?: number;
  search?: string;
  sortBy?: string;
  sortDir?: 'asc' | 'desc';
}

export interface DateRangeParams {
  startDate: string; // ISO date
  endDate: string;
}
